import fetch from "@/common/utils/serFetch";
import { APICUS } from "@public/utils/const";
import { GATEWAYSER } from '@/common/config/index'
// 处理意见
export const getHandlingOpinionsMsg = (word) => fetch.post(`${APICUS}/sysSensitiveWord/sensitiveVerification`, { word })

const moduleList = {
    selector: `${GATEWAYSER.SQSQT}/selector`
  }

export const commonApi = {
  // 服务商
  queryProvider() {
    return fetch.get(`${moduleList.selector}/im/serviceProvider`)
  },
  // 客服
  queryAgentOptions(reqData) {
    return fetch.post(`${moduleList.selector}/im/agent`, reqData)
  }
}

